type ExtractValueTypes<T> = T extends object ? T[keyof T] : never;

export const BACKGROUND_BLUR_AMOUNT = 3; // Between 1 and 10
export const BACKGROUND_THRESHOLD = 0.35;
export const DOWN_SAMPLE_FACTOR = 2; // Down Sampling Factor: 1 means no down sampling, 2 means half size, 4 means quarter size
export const EDGE_BLUR_AMOUNT = 4; // Between 1 and 10
export const EXCLUDE_BYSTANDERS = false;
export const FOREGROUND_THRESHOLD = 0.85;
export const LIGHT_WRAP_BLUR_AMOUNT = 1;
export const LIGHT_WRAP_EDGE_BAND = 0.25;
export const LIGHT_WRAP_INTENSITY = 0.8;
export const LIGHT_WRAP_TIGHTNESS = 1;
export const MASK_COMBINE_RATIO = 0.8;
export const MORPH_DILATE_RADIUS_PX = 6;
export const MORPH_ERODE_RADIUS_PX = 5;
export const MORPH_PASS = 4;
export const PERSON_CENTER: [number, number] = [0.5, 0.42]; // Pixel distance
export const PROCESSING_HEIGHT = 432;
export const PROCESSING_WIDTH = 768;
export const SIGMA_RANGE: [number, number] = [0.2, 0.8]; // [0, 1]
export const SIGMA_SPACE = 5.0; // Pixel distance
export const STRONG_EDGE_BLUR_AMOUNT = 2; // Only used for quarter size edge refinement

/**
 * Process status
 */
export const PROCESS_STATUS = {
    Closed: 'closed',
    Closing: 'closing',
    Destroyed: 'destroyed',
    Destroying: 'destroying',
    Error: 'Error',
    Idle: 'idle',
    New: 'new',
    Opened: 'opened',
    Opening: 'opening',
    Processing: 'processing',
    Updated: 'updated',
    Updating: 'updating',
} as const;
export type ProcessStatus = ExtractValueTypes<typeof PROCESS_STATUS>;

export const RENDER_EFFECT = {
    None: 'none',
    Blur: 'blur',
    Overlay: 'overlay',
} as const;

export const RENDER_BACKEND = {
    WebGL: 'webgl',
    WebGPU: 'webgpu',
    Canvas2D: 'canvas2d',
} as const;
export type RenderBackend = ExtractValueTypes<typeof RENDER_BACKEND>;

export type RenderEffects = ExtractValueTypes<typeof RENDER_EFFECT>;

export const RENDERING_EVENTS = {
    /**
     * Triggered when failed to create a context
     */
    ContextCreationError: 'ContextCreationError',
    /**
     * Triggered when context is lost
     */
    ContextLost: 'ContextLost',
    /**
     * Triggered when context is restored
     */
    ContextRestored: 'ContextRestored',
    /**
     * Triggered when there is unknown error
     */
    Error: 'Error',
    /**
     * Triggered when the processor is restarted
     */
    ProcessorRestarted: 'ProcessorRestarted',
    /**
     * Triggered when sampling error occurs
     */
    SamplingError: 'SamplingError',
} as const;

export type RenderingEvents = ExtractValueTypes<typeof RENDERING_EVENTS>;

export enum AbortReason {
    Close = 'close',
}
